import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { EntryFormComponent } from './features/entry-form/entry-form.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { HomeComponent } from './features/home/home.component';
import { MsalGuard } from '@azure/msal-angular';
import { UserPreferencesComponent } from './features/user-preferences/user-preferences.component';
import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { SuccessScreenComponent } from './features/entry-form/success-screen/success-screen.component';
import { AdminGuard } from './core/auth/admin.guard';

const entryRoute = 'login';

const routes: Routes = [
  {
    path: '',
    redirectTo: entryRoute,
    pathMatch: 'full',
  },
  {
    path: entryRoute,
    component: LoginComponent,
  },
  {
    path: 'preferences',
    canLoad: [MsalGuard],
    canActivate: [MsalGuard],
    component: MainLayoutComponent,
    data: { breadcrumb: 'home' },
    children: [
      {
        path: '',
        component: UserPreferencesComponent,
        data: { breadcrumb: 'detailsAndPreferences' },
      },
    ],
  },
  {
    path: 'home',
    component: HomeLayoutComponent,
    canLoad: [MsalGuard],
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        data: { breadcrumb: 'home' },
      },
    ],
  },
  {
    path: 'case',
    canLoad: [MsalGuard],
    canActivate: [MsalGuard],
    component: MainLayoutComponent,
    data: { breadcrumb: 'home' },
    children: [
      {
        path: '',
        component: EntryFormComponent,
        data: { breadcrumb: 'createCase' },
      },
      {
        path: ':id',
        component: EntryFormComponent,
        data: { breadcrumb: 'editCase' },
      },
      {
        path: 'success/:id',
        component: SuccessScreenComponent,
      },
    ],
  },
  {
    path: 'admin',
    //canLoad: [MsalGuard, AdminGuard],
    canActivate: [MsalGuard, AdminGuard],
    loadChildren: () => import('./features/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: '**',
    redirectTo: entryRoute,
    pathMatch: 'full',
  },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled', // Don't perform initial navigation in iframes
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
